<template>
  <RouterView />
</template>

<script>
export default {
  name: "App",
};


</script>

<style>
html,
body,
#app {
  height: 100vh !important;
  background-color: #181818 !important;
  overflow: hidden !important;
  color: white;
}
</style>

<style scoped>
.global-bg {
  position: absolute;
  top: 0px;
  left: 0px;

  height: 100%;
  width: 100%;

  background-image: url("@/assets/images/backgrounds/trianglify05.svg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
</style>
